import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Path } from "react-native-svg";

export const IconAirplane: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="square-filled-radius-0-stroke-2-IconAirplane"><Path d="M19.1574 2C17.8313 2 16.5596 2.52678 15.6219 3.46446L13.2391 5.84726L4.73909 2.84726L1.48812 6.09822L7.98812 11.0982L7.08635 12H5.08635L1.19531 15.891L6.22383 17.7767L8.10953 22.8052L12.0006 18.9142V16.9142L12.9023 16.0124L17.9023 22.5124L21.1533 19.2615L18.1533 10.7615L20.5361 8.37868C21.4738 7.441 22.0006 6.16923 22.0006 4.84315V2H19.1574Z" fill="currentColor"/></CentralIconBase>;
});

export default IconAirplane;
